import { Login } from '~/services/main/components/auth/Login/Login';

export const LoginPage = () => {
  return <Login />;
};
